module.exports = __webpack_public_path__ + "img/icon-edit.62b7cbe4.svg";